// Modify default `options`
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function(params, facet) {
    if (facet.name === 'vendor') {
      const originalTransformItems = params.transformItems;
      const vendorLabels = {
        'Automic Gold Studio': 'In stock',
        Custom: 'Custom-made',
      };

      return {
        ...params,
        sortBy: ['name:asc'],
        transformItems(items, metadata) {
          const transformedItems = originalTransformItems ? originalTransformItems(items, metadata) : items;

          return transformedItems
            .filter(item => Object.prototype.hasOwnProperty.call(vendorLabels, item.label))
            .map(item => ({
              ...item,
              label: vendorLabels[item.label],
            }));
        },
      };
    }

    return params;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Modify default options, then return them
    options.enterKeyHint = "search";
    options.placeholder = "Type here";
    options.openOnFocus = true;
    options.detachedMediaQuery = "(max-width: 680px)";
    return options;
  });

  //------------------------------start-------------------------//
  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    // Modify default options, then return them
    const { html, state } = templateOptions;
    const { query } = state;
    return html``;
  });
  //------------------------------end-------------------------//


  //------------------------------start-top-search-and-right-bar-------------------------//
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections top-search-section">
          ${templateOptions.state.query == '' &&
            html`<div class="aa-PanelSection--center top-search">
            <h2>Trending Products</h2>
            </div>`
          }
          <div class="aa-PanelSection--products">
            ${elements.products}
          </div>
          ${templateOptions.state.query != '' &&
            html`<div class="aa-PanelSection--articles">
              <h2>Articles</h2>
              ${elements.articles}
            </div>`
          }
          ${templateOptions.state.query != '' && elements.pages &&
            html`<div class="aa-PanelSection--pages">
              <h2>Pages</h2>
              ${elements.pages}
            </div>`
          }
          ${elements.redirectUrlPlugin}
          
        </div>
      </div>
    `;
  });
  //------------------------------end-------------------------//


  //------------------------------start-article-card-------------------------//
  algoliaShopify.hooks.registerHook('beforeAutocompleteArticlesTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { item, html, components } = templateOptions;

    return html`
      <a href="${itemLink}" class="aa-ItemLink aa-ArticleItem">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemIcon aa-ItemIcon--noBorder" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 3.75h9.75L18 6v14.25H6V3.75Z"></path>
                <path stroke-linecap="round" stroke-width="1.5" d="M9 9h6M9 12h6M9 15h4"></path>
              </svg>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });
  //------------------------------end-article-card-------------------------//

  algoliaShopify.hooks.registerHook('beforeAutocompletePagesTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { item, html, components } = templateOptions;

    return html`
      <a href="${itemLink}" class="aa-ItemLink aa-ArticleItem aa-PageItem">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemIcon aa-ItemIcon--noBorder" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 3.75h9.75L18 6v14.25H6V3.75Z"></path>
                <path stroke-linecap="round" stroke-width="1.5" d="M9 9h6M9 12h6M9 15h4"></path>
              </svg>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });


  //------------------------------start-------------------------//
  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;

    // Function to convert <span> to <img> inside the copied content
    function convertSpansToImages(container) {
      const spans = container.querySelectorAll('span[data-src]');

      // Loop through each <span> with a data-src attribute
      spans.forEach(span => {
        const img = document.createElement('img');
        img.src = span.getAttribute('data-src') + '&width=500';
        img.alt = span.getAttribute('alt') || ''; // Set alt attribute if available, else empty
        span.replaceWith(img); // Replace the <span> with the new <img> element
      });
    }

    // Copy the recommendation source and convert its image placeholders.
    function copySearchRecommendations() {
      const searchNoResult = document.querySelector('.aa-Panel .search-no-result');

      if (!searchNoResult) return;

      const recommendationsSource = document.querySelector('.search-recommendations-data');

      if (!recommendationsSource) return;
      if (searchNoResult.querySelector('.search-recommendations__list .aa-Item')) return;

      searchNoResult.innerHTML = recommendationsSource.innerHTML;
      convertSpansToImages(searchNoResult);
    }

    // Execute content insertion after the hook completes rendering
    setTimeout(copySearchRecommendations, 0);
  
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <p class="aa-NoResultsHeader">
          Sorry no results found.
        </p>
        <h2 class="search-recommendations__widget-title">
          <span class="title-text">You May Also Like</span>
        </h2>
        <div class="search-no-result"></div>
      </div>
    `;
  });
  
  //------------------------------end-------------------------//

  
});


  document.addEventListener("algolia.hooks.initialize", function () {
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      function (_defaultTemplate, templateOptions, distinct, itemLink) {
        // Modify default options, then return them
        const { html, item, components } = templateOptions;
        const regex = /<\/?[^>]+(>|$)/g;
        const priceRange = algoliaShopify.helpers.displayPrice(item, distinct);
        const checkRangePrice = priceRange.includes('-');
        const priceProduct = checkRangePrice ? priceRange.split(" - ")[0].replace('.00', '') : priceRange.replace('.00', '');
        const titleProduct = item.title.replace(regex, ' ');

        let priceWithCode = priceProduct;
        if (window.ShopCurrency && window.ShopCurrency.symbol.includes('$')) {
          if (window.ShopCurrency.iso_code !== 'USD') {
            priceWithCode += ' ' + window.ShopCurrency.iso_code;
          }
        }
        

        const originalUrl = algoliaShopify.helpers.compactImage(item);
        const updatedUrl = originalUrl.replace(/compact/, '576x');

        
        // const checkSecondTitle = item.meta && item.meta.global && item.meta.global.second_title ? item.meta.global.second_title.replace(regex, ' ') : '';
        
        // <small>${checkSecondTitle}</small>

        const link = itemLink = itemLink.replace(/\/$/, '');

        return html`
          <a
            href="${link}"
            class="aa-ItemLink aa-ProductItem"
            onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
          >
            <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                <img
                  src="${updatedUrl}"
                  alt="${titleProduct}"
                />
              </div>
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">
                  ${titleProduct}
                    <span class="algolia-variant">
                      ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                    </span>
                  </div>
                </div>
                <div class="aa-ItemContentPrice">
                  <div class="aa-ItemContentPriceCurrent">
                    <p>${priceWithCode}</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        `;
      }
    );
  });
  


//-------------------------------------------------------------------------------------------------------------------------------------------------------
//Instant customize
//-------------------------------------------------------------------------------------------------------------------------------------------------------

document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
      const priceRangeInst = algoliaShopify.helpers.displayPrice(hit, hit._distinct);
      const regex = /<\/?[^>]+(>|$)/g;
      const checkRangePrice = priceRangeInst.includes('-');
      const priceInst = checkRangePrice ? priceRangeInst.split(" - ")[0].replace('.00', '') : priceRangeInst.replace('.00', '');
      const checkSecondTitle = hit.meta && hit.meta.global && hit.meta.global.second_title ? hit.meta.global.second_title.replace(regex, ' ') : '';
      const titleProduct = hit.title.replace(regex, ' ');
  
      return html`
        <div
          class="ais-hit ais-product" 
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
        >
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.largeImage(hit)}"
            alt="${titleProduct} - ${hit.variant_title}"
          />
  
          <div class="ais-hit--details">
            <p class="ais-hit--title">
              <a
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                onclick="void(0)"
                title="${algoliaShopify.helpers.fullTitle(
                  titleProduct,
                  hit._distinct,
                  hit.variant_title
                )}"
              >
                ${titleProduct}
              </a>
            </p>
            
            ${checkSecondTitle &&
              html`
                <p
                  class="ais-hit--subtitle"
                  title="${checkSecondTitle}"
                >
                  ${checkSecondTitle}
                </p>
              `}

            <p class="ais-hit--price">
              <b>${priceInst}</b>
            </p>
            <!-- Extra info examples - Remove the display: none to show them -->
            <p class="ais-hit--info" style="display: none">
              ${hit.sku &&
                html`
                  <span class="algolia-sku"
                    >${components.Highlight({ attribute: 'sku', hit })}</span
                  >
                `}
              ${hit.barcode &&
                html`
                  <span class="algolia-barcode"
                    >${components.Highlight({ attribute: 'barcode', hit })}</span
                  >
                `}
              ${hit.weight &&
                html`
                  <span class="algolia-weight">${hit.weight}</span>
                `}
              ${!hit.taxable &&
                html`
                  <span class="algolia-taxable"
                    >${algoliaShopify.translations.taxFree}</span
                  >
                `}
            </p>
            <!-- Tags example - Remove the display: none to show them -->
            <p class="ais-hit--tags" style="display: none">
              ${hit?._highlightResult.tags?.map(
                tag =>
                  html`
                    <span class="ais-hit--tag">${tag.value}</span>
                  `
              )}
            </p>
            ${!hit._distinct &&
              html`
                <form
                  id="algolia-add-to-cart-${hit.objectID}"
                  style="display: none;"
                  action="/cart/add"
                  method="post"
                  enctype="multipart/form-data"
                >
                  <input type="hidden" name="id" value="${hit.objectID}" />
                </form>
                <p class="ais-hit--cart">
                  ${hit.can_order
                    ? html`
                        <button
                          class="ais-hit--cart-button"
                          data-form-id="algolia-add-to-cart-${hit.objectID}"
                        >
                          ${algoliaShopify.translations.addToCart}
                        </button>
                      `
                    : html`
                        <button
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      `}
                </p>
              `}
          </div>
        </div>
      `;
    });
  });


  document.addEventListener('algolia.hooks.initialize', function() {
    let articlesRequestController;
    let articlesRequestId = 0;
    let pagesRequestController;
    let pagesRequestId = 0;
    let instantSearchClient;
    let lastArticlesQuery;
    let lastPagesQuery;

    function getArticleUrl(hit) {
      const root = window.Shopify?.routes?.root || '/';
      const blogHandle = hit.blog?.handle;

      if (!blogHandle || !hit.handle) return root;
      return `${root}blogs/${blogHandle}/${hit.handle}`.replace(/\/+/g, '/');
    }

    function getPageUrl(hit) {
      const root = window.Shopify?.routes?.root || '/';
      if (hit.url) return hit.url;
      if (!hit.handle) return root;
      return `${root}pages/${hit.handle}`.replace(/\/+/g, '/');
    }

    function renderInstantSearchPages(hits, query) {
      const section = document.querySelector('.ais-pages-results');
      const list = section?.querySelector('.ais-pages-results__list');
      const pagesTab = document.querySelector('[data-results-tab="pages"]');
      const pagesCount = document.querySelector('[data-results-count="pages"]');

      if (!section || !list) return;

      list.replaceChildren();

      if (pagesCount) {
        pagesCount.textContent = query
          ? `(${new Intl.NumberFormat(document.documentElement.lang || 'en').format(hits.length)})`
          : '';
      }

      if (!query || !hits.length) {
        section.hidden = true;
        if (pagesTab) pagesTab.hidden = true;

        if (document.querySelector('.ais-page')?.dataset.activeResultsTab === 'pages') {
          setSearchResultsTab('products');
        }
        return;
      }

      hits.forEach(hit => {
        const item = document.createElement('article');
        const link = document.createElement('a');
        const icon = document.createElement('span');
        const content = document.createElement('div');
        const title = document.createElement('h3');

        item.className = 'ais-article-card ais-page-card';
        link.className = 'ais-article-card__link';
        link.href = getPageUrl(hit);
        icon.className = 'ais-article-card__icon';
        icon.setAttribute('aria-hidden', 'true');
        content.className = 'ais-article-card__content';
        title.className = 'ais-article-card__title';
        title.textContent = hit.title || '';

        content.appendChild(title);
        link.append(icon, content);
        item.appendChild(link);
        list.appendChild(item);
      });

      section.hidden = false;
      if (pagesTab) pagesTab.hidden = false;
    }

    function renderInstantSearchArticles(hits, query) {
      const section = document.querySelector('.ais-articles-results');
      const list = section?.querySelector('.ais-articles-results__list');
      const articlesTab = document.querySelector('[data-results-tab="articles"]');
      const articlesCount = document.querySelector('[data-results-count="articles"]');

      if (!section || !list) return;

      list.replaceChildren();

      if (articlesCount) {
        articlesCount.textContent = query
          ? `(${new Intl.NumberFormat(document.documentElement.lang || 'en').format(hits.length)})`
          : '';
      }

      if (!query || !hits.length) {
        section.hidden = true;
        if (articlesTab) articlesTab.hidden = true;

        if (document.querySelector('.ais-page')?.dataset.activeResultsTab === 'articles') {
          setSearchResultsTab('products');
        }
        return;
      }

      hits.forEach(hit => {
        const item = document.createElement('article');
        const link = document.createElement('a');
        const icon = document.createElement('span');
        const content = document.createElement('div');
        const title = document.createElement('h3');

        item.className = 'ais-article-card';
        link.className = 'ais-article-card__link';
        link.href = getArticleUrl(hit);

        icon.className = 'ais-article-card__icon';
        icon.setAttribute('aria-hidden', 'true');
        link.appendChild(icon);

        content.className = 'ais-article-card__content';
        title.className = 'ais-article-card__title';
        title.textContent = hit.title || '';
        content.appendChild(title);

        link.appendChild(content);
        item.appendChild(link);
        list.appendChild(item);
      });

      section.hidden = false;
      if (articlesTab) articlesTab.hidden = false;
    }

    function setSearchResultsTab(tabName) {
      const page = document.querySelector('.template-search .ais-page');

      if (!page) return;

      page.dataset.activeResultsTab = tabName;

      page.querySelectorAll('[data-results-tab]').forEach(button => {
        const isActive = button.dataset.resultsTab === tabName;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      page.querySelector('.ais-block')?.setAttribute('aria-hidden', String(tabName !== 'products'));
      page.querySelector('.ais-articles-results')?.setAttribute('aria-hidden', String(tabName !== 'articles'));
      page.querySelector('.ais-pages-results')?.setAttribute('aria-hidden', String(tabName !== 'pages'));
    }

    async function searchInstantSearchPages(query) {
      pagesRequestController?.abort();
      const requestId = ++pagesRequestId;

      if (!query.trim()) {
        renderInstantSearchPages([], '');
        return;
      }

      renderInstantSearchPages([], '');

      const config = algoliaShopify.config || {};
      const applicationId = config.application_id || config.applicationId;
      const searchApiKey = config.search_api_key || config.searchApiKey;
      const indexName = `${config.index_prefix || 'shopify_'}pages`;
      const params = {
        query,
        hitsPerPage: 24,
        attributesToRetrieve: ['title', 'handle', 'url'],
      };

      try {
        if (instantSearchClient?.search) {
          const searchRequest = { indexName, params };
          let result;

          try {
            result = await instantSearchClient.search([searchRequest]);
          } catch (_legacyClientError) {
            result = await instantSearchClient.search({ requests: [searchRequest] });
          }

          if (requestId !== pagesRequestId) return;
          renderInstantSearchPages(result.results?.[0]?.hits || [], query);
          return;
        }

        if (!applicationId || !searchApiKey) {
          throw new Error('Page search: Algolia search client or credentials are unavailable');
        }

        pagesRequestController = new AbortController();
        const response = await fetch(
          `https://${applicationId.toLowerCase()}-dsn.algolia.net/1/indexes/${encodeURIComponent(indexName)}/query`,
          {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'x-algolia-application-id': applicationId,
              'x-algolia-api-key': searchApiKey,
            },
            body: JSON.stringify(params),
            signal: pagesRequestController.signal,
          }
        );

        if (!response.ok) throw new Error(`Page search failed: ${response.status}`);

        const result = await response.json();
        if (requestId !== pagesRequestId) return;
        renderInstantSearchPages(result.hits || [], query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
          renderInstantSearchPages([], '');
        }
      }
    }

    async function searchInstantSearchArticles(query) {
      articlesRequestController?.abort();
      const requestId = ++articlesRequestId;

      if (!query.trim()) {
        renderInstantSearchArticles([], '');
        return;
      }

      renderInstantSearchArticles([], '');

      const config = algoliaShopify.config || {};
      const applicationId = config.application_id || config.applicationId;
      const searchApiKey = config.search_api_key || config.searchApiKey;
      const indexName = `${config.index_prefix || 'shopify_'}articles`;

      try {
        if (instantSearchClient?.search) {
          const searchRequest = {
            indexName,
            params: {
              query,
              hitsPerPage: 24,
              attributesToRetrieve: ['title', 'handle', 'blog'],
            },
          };
          let result;

          try {
            result = await instantSearchClient.search([searchRequest]);
          } catch (_legacyClientError) {
            result = await instantSearchClient.search({ requests: [searchRequest] });
          }

          if (requestId !== articlesRequestId) return;
          const articleResult = result.results?.[0];
          renderInstantSearchArticles(articleResult?.hits || [], query);
          return;
        }

        if (!applicationId || !searchApiKey) {
          throw new Error('Article search: Algolia search client or credentials are unavailable');
        }

        articlesRequestController = new AbortController();

        const response = await fetch(
          `https://${applicationId.toLowerCase()}-dsn.algolia.net/1/indexes/${encodeURIComponent(indexName)}/query`,
          {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'x-algolia-application-id': applicationId,
              'x-algolia-api-key': searchApiKey,
            },
            body: JSON.stringify({
              query,
              hitsPerPage: 24,
              attributesToRetrieve: ['title', 'handle', 'blog'],
            }),
            signal: articlesRequestController.signal,
          }
        );

        if (!response.ok) throw new Error(`Article search failed: ${response.status}`);

        const result = await response.json();
        if (requestId !== articlesRequestId) return;
        renderInstantSearchArticles(result.hits || [], query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
          renderInstantSearchArticles([], '');
        }
      }
    }

    algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function(options) {
      instantSearchClient = options.searchClient;
      return options;
    });

    document.addEventListener('algolia.instantSearch.onRender', function() {
      const input = document.querySelector('.template-search .ais-SearchBox-input');
      const query = input?.value?.trim() || '';
      const productsCount = document.querySelector('[data-results-count="products"]');
      const productsCountSource = document.querySelector('.template-search .ais-stats-container');

      if (productsCount) {
        const statsText = productsCountSource?.textContent?.trim() || '';
        const totalMatch =
          statsText.match(/out\s*of\s*([\d,.\u00a0\u202f ]+)/i) ||
          statsText.match(/([\d,.\u00a0\u202f ]+)\s*results?\s*found/i);
        const countMatch = totalMatch || statsText.match(/[\d,.]+/);
        const count = countMatch?.[1]?.trim() || countMatch?.[0]?.trim() || '';

        productsCount.textContent = count ? `(${count})` : '';
      }

      if (query !== lastArticlesQuery) {
        lastArticlesQuery = query;
        searchInstantSearchArticles(query);
      }

      if (query !== lastPagesQuery) {
        lastPagesQuery = query;
        searchInstantSearchPages(query);
      }
    });

    document.addEventListener('click', function(event) {
      const tab = event.target.closest('[data-results-tab]');

      if (!tab) return;
      setSearchResultsTab(tab.dataset.resultsTab);
    });

    algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
      return html`
        <div class="ais-page" data-active-results-tab="products">
          <div class="ais-page-top">
            <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
            <div class="ais-input">
              <div class="ais-search-box-container"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>
          </div>
          <div class="ais-results-tabs" role="tablist" aria-label="Search result types">
            <button
              class="ais-results-tabs__button is-active"
              type="button"
              role="tab"
              aria-selected="true"
              aria-controls="ais-product-results"
              data-results-tab="products"
            >Products <span class="ais-results-tabs__count" data-results-count="products"></span></button>
            <button
              class="ais-results-tabs__button"
              type="button"
              role="tab"
              aria-selected="false"
              aria-controls="ais-article-results"
              data-results-tab="articles"
              tabindex="-1"
              hidden
            >Articles <span class="ais-results-tabs__count" data-results-count="articles"></span></button>
            <button
              class="ais-results-tabs__button"
              type="button"
              role="tab"
              aria-selected="false"
              aria-controls="ais-page-results"
              data-results-tab="pages"
              tabindex="-1"
              hidden
            >Pages <span class="ais-results-tabs__count" data-results-count="pages"></span></button>
          </div>
          <div class="ais-page-body">
            <div class="ais-facets-button">
              Show filters
            </div>
            <div class="ais-facets">
              <div class="ais-clear-refinements-container"></div>
              <div class="ais-current-refined-values-container"></div>
              ${data.facets.map(
                (facet, index) => index === 0
                  ? html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                    >
                      
                      <input
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                      />

                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header"
                        >${facet.title}</label
                      >
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `
                  : html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                    >
                      
                      <input
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                        checked="checked"
                      />
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header"
                        >${facet.title}</label
                      >
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `
              )}            
            </div>
            <div class="ais-cards-container">
              <div class="ais-block" id="ais-product-results" role="tabpanel">
                <div class="ais-search-header">
                  <div class="ais-stats-container"></div>
                  <div class="ais-change-display">
                    <span class="ais-change-display-block ais-change-display-selected"
                      ><i class="fa fa-th-large"></i
                    ></span>
                    <span class="ais-change-display-list"
                      ><i class="fa fa-th-list"></i
                    ></span>
                  </div>
                  <div class="ais-sort">
                    ${data.multipleSortOrders
                      ? html`
                          ${algoliaShopify.translations.sortBy}
                          <span class="ais-sort-orders-container"></span>
                        `
                      : html`
                          ${algoliaShopify.translations.sortBy}
                          ${algoliaShopify.translations.relevance}
                        `}
                  </div>
                </div>
                <div class="ais-hits-container ais-results-as-block"></div>
              </div>
              <div class="ais-pagination-container"></div>
              <section class="ais-articles-results" id="ais-article-results" role="tabpanel" aria-live="polite" aria-hidden="true" hidden>
                <div class="ais-articles-results__list"></div>
              </section>
              <section class="ais-pages-results" id="ais-page-results" role="tabpanel" aria-live="polite" aria-hidden="true" hidden>
                <div class="ais-pages-results__list"></div>
              </section>
            </div>
          </div>
        </div>
      `;
    });
  });
